<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
       {{'DISCARD_CHANGES' | translate}} 
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>


<div class="col-md-12">
    <mat-dialog-content class="contentPadding">
        <section>
            {{'DISCARD_MESSAGE' | translate}}</section>
    </mat-dialog-content>
        <mat-dialog-actions class="footer-btn" align="end">
        <div>
            <button class="openCloseBtn" 
                    mat-raised-button color="primary" 
                    (click)="discard()">
                    {{'COMMON_DIALOGS_BTN_LABELS.YES' | translate}}
            </button>
            <button class="openCloseBtn" 
                    mat-raised-button color="warn" 
                    [mat-dialog-close]>
                    {{'COMMON_DIALOGS_BTN_LABELS.NO' | translate}}
            </button>
        </div>
    </mat-dialog-actions>
</div>
